import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { BuildersTemporarySupplyPage, BuildersTemporarySupplyPageProps } from "./BuildersTemporarySupplyPage";

export const EMPTY_PAGE_CONTENT: BuildersTemporarySupplyPageProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/electricity/new-connection/builders-temporary-supply";

export const BuildersTemporarySupplyPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<BuildersTemporarySupplyPageProps>("electricity_builders_temporary_supply", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <BuildersTemporarySupplyPage {...routeProps} {...content} />;
};
